import { makeQuery } from "src/queries/makeQuery";

export const useQuerySystemSettings = makeQuery<any>("/api/system-settings");

export const useQuerySystemSettingsSchema = makeQuery("/api/system-settings/schema");

export interface PublicSystemSettings {
  enable_auto_tune: boolean;
  enable_apply_step: boolean;
  enable_test_on_staging: boolean;
  default_dashboard_tab: string;
  /** Cost sign: one char replaces "$", a word is appended, "" = real currency. */
  cost_unit_label?: string;
}

export const useQueryPublicSystemSettings = makeQuery<PublicSystemSettings>(
  "/api/system-settings/public"
);
